import React, { createRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { IconGlobalTag, IconSharedDocument } from '../Icons';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
const handleBackgroundColor = (state) => {
    switch (state.toUpperCase()) {
        case 'DEFAULT':
            return '#e6ecf2';
        case 'SELECTED':
            return '#e8f4fb';
        case 'ACTIVE':
            return '#ffffff';
        default:
            return '#e6ecf2';
    }
};
const handleTextColor = (state) => {
    switch (state.toUpperCase()) {
        case 'DEFAULT':
            return '#00214d';
        case 'SELECTED':
            return '#1c92dd';
        case 'ACTIVE':
            return '#1c92dd';
        default:
            return '#00214d';
    }
};
const handleIconType = (type, state) => {
    const color = handleTextColor(state);
    switch (type) {
        case 'ORGANIZATION':
            return React.createElement(IconSharedDocument, { color: color });
        case 'ORGANIZATION_DEFAULT':
            return React.createElement(IconGlobalTag, { color: color });
        default:
            return null;
    }
};
const Wrapper = styled.span `
  display: inline-flex;
  flex-direction: row;
  padding: 2px 10px;
  height: 28px;
  border-radius: 20px;
  line-height: 24px;
  background-color: ${({ state }) => handleBackgroundColor(state)};
  ${({ clickable }) => (clickable ? 'cursor: pointer;' : 'cursor: default;')}
  max-width: 200px;
  margin: 5px 2px 5px 0;

  .delete-icon {
    display: inline-block;
    padding: 0px 3px;
    margin-top: -1px;
    text-align: center;
    cursor: pointer;
  }

  &:hover {
    background-color: #b4def8;
  }

  @media (max-width: 1200px) {
    margin: 6px 8px 6px 0;
  }

  @media (max-width: 768px) {
    margin: 8px 12px 8px 0;
  }
`;
const Text = styled.span `
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${({ state }) => handleTextColor(state)};
  align-self: center;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:focus {
    outline: 0;
  }
`;
const IconWrapper = styled.div `
  margin-left: 4px;
  margin-bottom: 8px;
`;
const Chip = ({ id, text, state = 'DEFAULT', handleClick, deletable, onDelete, className = '', clickable = false, type, }) => {
    const textRef = createRef();
    const [hasOverflowingChildren, setHasOverflowingChildren] = useState(false);
    useEffect(() => {
        const element = textRef;
        const hasOverflowing = element.current.offsetWidth !== element.current.scrollWidth;
        setHasOverflowingChildren(hasOverflowing);
    }, []);
    return (React.createElement(Tippy, { content: React.createElement("span", null, text), placement: "auto", disabled: !hasOverflowingChildren },
        React.createElement(Wrapper, { onClick: () => {
                if (handleClick)
                    return handleClick(id);
            }, state: state, clickable: !!handleClick || clickable, className: className },
            deletable && type !== 'ORGANIZATION_DEFAULT' && (React.createElement("span", { onClick: onDelete, className: 'delete-icon' }, "\u00D7")),
            React.createElement(Text, { state: state, className: "tooltip-icon", ref: textRef }, text),
            type && React.createElement(IconWrapper, null, handleIconType(type, state)))));
};
export default Chip;
